export const containerQuery = (minWidthPx, styles) => ({
    [`@container (min-width: ${minWidthPx}px)`]: styles,
})

export const containerQueryDown = (maxWidthPx, styles) => ({
    [`@container (max-width: ${maxWidthPx - 1}px)`]: styles,
})
